import 'catalog/components/CatalogHeader/CatalogHeader.scss';

import React from 'react';
import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

const CatalogHeader = () => {
    const content = ContentZonesService.getContentZone('widget.catalog', 'widget.catalog.buy.online.banner');

    const bannerImage = content?.getValue() !== '' && (
        <div className="catalog-promo-banner">
            <img src={content?.getValue()} alt={LocaleService.t('CATALOG_BANNER')} />
        </div>
    );

    return (
        <section className="section-catalog-header">
            {bannerImage}
            <div className="catalog-header">
                <h1 className="sr-title-1 is-centered">{LocaleService.t('catalogHeader.findModel')}</h1>
            </div>
        </section>
    );
};
CatalogHeader.displayName = 'CatalogHeader';

export default CatalogHeader;
